import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import BaseErrorBoundary from './Base';

const styles = {
  errorContainer: {
    backgroundColor: '#333',
    border: '1px solid #000',
    borderRadius: 10,
  },
  errorHeader: {
    padding: 15,
    backgroundColor: '#2c4556',
    textAlign: 'center' as const,
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorBody: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
  },
};

class ErrorBoundary extends BaseErrorBoundary {
  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <Box mt={2}>
          <Grid container justifyContent='center' alignItems='center'>
            <Grid
              size={{
                sm: 6,
              }}
            >
              <Paper style={styles.errorContainer}>
                <Box p={3}>
                  <div style={styles.errorBody}>
                    <Typography variant='h5'>
                      An unexpected error has occurred.
                    </Typography>

                    <p>
                      <Typography>
                        Something didn't work out as well as we wanted it to and
                        the page broke. We sent our team an automatic
                        notification of this issue and we will be investigating
                        it as soon as possible!
                      </Typography>
                    </p>

                    <p>
                      <Typography>
                        In the meantime, feel free to try again.
                      </Typography>
                    </p>

                    <p>
                      <Typography>
                        If the issue persists, please contact Reliance
                        Telephone.
                      </Typography>
                    </p>

                    <details style={{ whiteSpace: 'pre-wrap' }}>
                      <summary>Technical error details</summary>
                      <div style={{ marginTop: 10 }}>
                        <strong style={{ marginTop: 10 }}>
                          {this.state.error && this.state.error.toString()}
                        </strong>
                      </div>
                      <pre>
                        {'    ' +
                          this.state.errorInfo.componentStack?.trimStart()}
                      </pre>
                    </details>
                  </div>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
